export default __webpack_public_path__ + "assets/img/ict-rectangleFilled.24e1d0bbabacbe9b2dcd73424df28ba8.svg";